module.exports = __webpack_public_path__ + "img/icon_redeem_code.398557a9.svg";